import { createFileRoute } from '@tanstack/react-router'

import { ServiceHistoryPage } from '../../components/service-history/components/ServiceHistoryPage'

export const Route = createFileRoute('/app/service-history')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ServiceHistoryPage />
}
